import { Bank, BankAccount, PayInBankType } from '../../../models/bankAccount'

export const getBankAccountData = (data: BankAccount): Bank[] => {
  console.log('getBankAccount', data)
  const originalJSON: BankAccount = JSON.parse(JSON.stringify(data))

  const convertedJSON: PayInBankType = {
    type: originalJSON.paymentMode,
    name: originalJSON.branchCode,
    banks: []
  }

  originalJSON.payInBankTypes.forEach(payInBankType => {
    payInBankType.banks.forEach(bank => {
      const existingBank = convertedJSON.banks.find(b => b.bankCode === bank.bankCode)
      if (existingBank) {
        existingBank.accountNumbers = Array.from(
          new Set([...existingBank.accountNumbers, ...bank.accountNumbers])
        )
      } else {
        convertedJSON.banks.push({
          bankCode: bank.bankCode,
          bankName: bank.bankName,
          accountNumbers: bank.accountNumbers
        })
      }
    })
  })

  return convertedJSON.banks
}

export function findPayInBankTypesByAccountNo(accountNo: string, data: BankAccount): string {
  const foundPayInBankTypes: PayInBankType[] = []
  const originalJSON: BankAccount = JSON.parse(JSON.stringify(data))

  originalJSON.payInBankTypes.forEach(payInBankType => {
    payInBankType.banks.forEach(bank => {
      if (bank.accountNumbers.includes(accountNo)) {
        foundPayInBankTypes.push(payInBankType)
      }
    })
  })
  if (!foundPayInBankTypes) return ''
  if (foundPayInBankTypes.length == 0) return ''
  return foundPayInBankTypes[0].type
}
